import { MapPinLocationControl } from '@components/Map/MapPinLocationControl';
import { MapPinSelectionDialog } from '@components/Map/MapPinSelectionDialog';
import { useState } from 'react';
import {
  useBookingProposalActions,
  useBookingProposalAddress,
  useBookingProposalPinLocation
} from './bookingProposalStore';

export const MapPinSelectionProposalStore = () => {
  const [isPickerOpen, setIsPickerOpen] = useState(false);
  const { setPinLocation } = useBookingProposalActions();
  const pinLocation = useBookingProposalPinLocation();
  const selectedAddress = useBookingProposalAddress();

  const initialLocationLatitude = pinLocation?.lat ?? selectedAddress?.latitude;
  const initialLocationLongitude = pinLocation?.lng ?? selectedAddress?.longitude;

  return (
    <>
      <MapPinLocationControl pinLocation={pinLocation} onOpenPicker={() => setIsPickerOpen(true)} />
      <MapPinSelectionDialog
        isOpen={isPickerOpen}
        initialLatitude={initialLocationLatitude}
        initialLongitude={initialLocationLongitude}
        addressLatitude={selectedAddress?.latitude}
        addressLongitude={selectedAddress?.longitude}
        onLocationSelected={(lat, lng) => {
          setPinLocation({ lat, lng });
          setIsPickerOpen(false);
        }}
        onClose={() => setIsPickerOpen(false)}
      />
    </>
  );
};
